import { Component } from '@angular/core';
import { AppRoutesEnum } from '@shared/enums';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
    urls = AppRoutesEnum;

    constructor(private router: Router) {}

    goToDashboard(): void {
        if (this.router.url.toLowerCase().indexOf(this.urls.DASHBOARD) > -1) {
            this.router.navigate([AppRoutesEnum.DASHBOARD]).then(() => {
                window.location.reload();
            });
        } else {
            this.router.navigate([AppRoutesEnum.DASHBOARD]);
        }
    }

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
    }
}
